export enum AuthorizationType {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete'
}

export enum AuthorizationConcept {
  ASSET = 'asset',
  ASSET_CONTENT = 'asset_content',
  ASSET_VAR_THRESHOLD = 'ASSET_VAR_THRESHOLD',
  ASSET_TEMPLATE = 'ASSET_TEMPLATE',
  AUDIT_TRAIL = 'AUDIT_TRAIL',
  BUSINESS_PROFILE = 'BUSINESS_PROFILE',
  CALENDAR = 'CALENDAR',
  CONNECTOR = 'connector',
  CONTACT = 'CONTACT',
  DATAGUARD = 'DATAGUARD',
  DEVICE = 'device',
  DEVICE_CONFIGURATOR = 'DEVICE_CONFIGURATOR',
  DEVICE_TEMPLATE = 'DEVICE_TEMPLATE',
  ESCALATION_PROTOCOL = 'ESCALATION_PROTOCOL',
  EVENT = 'event',
  FIRMWARE = 'firmware',
  GRAPH = 'GRAPH',
  IOT_ASSISTANT = 'IOT_ASSISTANT',
  NOTIFICATION_TEMPLATE = 'NOTIFICATION_TEMPLATE',
  ORGANIZATION_TREE = 'ORGANIZATION_TREE',
  PO_EVENT_RULE = 'PO_EVENT_RULE',
  PRODUCT_CATALOG = 'PRODUCT_CATALOG',
  REPORTING = 'REPORTING',
  SCHEDULER = 'SCHEDULER',
  SENSOR = 'sensor',
  SITE = 'site',
  TAG = 'TAG',
  TEAM_PLANNING = 'TEAM_PLANNING',
  TRANSLATION = 'TRANSLATION',
  TOPIC = 'TOPIC',
  USER = 'USER',
  USER_STATUS = 'USER_STATUS',
  WORKORDER = 'WORKORDER'
}

/** Privileges of the current business profile: concept → allowed authorization types. */
export type Privileges = Record<string, string[]>;
